import CopyWrapper from "components/Common/CopyWrapper";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import {
  COLOR_USER_TYPE,
  LIST_CHANNEL_USER_OPTION,
  LIST_OPTION_OS,
  LIST_OPTION_USER_TYPE,
} from "helpers/constans";
import { formatDateStringToKorea, getPlatFormImage } from "helpers/format";
import IPHONE_MODELS from "helpers/iphone_models";
import React, { useEffect } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { Card, CardBody, Col, Input, Label, Row } from "reactstrap";
import { capitalizeFirstLetter } from "utils";
import noUser from "../../../assets/images/no-user.png";

registerLocale("en", en);
registerLocale("ko", ko);

const AccountInfoTab = ({ data }: any) => {
  const { t, i18n } = useTranslation();
  const user_provider = data?.provider;
  let lowPlatform = user_provider ? user_provider.toLowerCase() : "";
  let imgPlatform = getPlatFormImage(lowPlatform);

  const deviceOS = data?.user_device?.device?.os || "";
  let imgOS = getPlatFormImage(deviceOS);
  let imgChannel = getPlatFormImage(data?.install_source);

  let emailSNS = data?.email ? data?.email : data?.provider_id;
  const userType =
    data?.user_device?.login_type === "GUEST" ? "guest" : "normal";

  let deviceModel = data?.user_device?.device?.model;
  const os = data?.user_device?.device?.os;
  if (os === "ios") {
    deviceModel = deviceModel
      ? IPHONE_MODELS[deviceModel as keyof typeof IPHONE_MODELS] ?? deviceModel
      : "";
  }

  useEffect(() => {
    document.title = `${t("Account Info")} | ShowStar`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <Row>
        <Col lg={12} className="mt-4 px-4">
          <div>
            <div
              className="d-flex flex-column mb-4 pt-3 pb-1 px-3 position-relative"
              style={{
                border: "1px dashed var(--vz-primary)",
                borderRadius: "4px",
              }}
            >
              <span
                className="text-primary position-absolute fs-13 px-1"
                style={{
                  backgroundColor: "var(--vz-secondary-bg)",
                  top: "0px",
                  transform: "translateY(-50%)",
                }}
              >
                {t("Info")}
              </span>
              <div className="d-flex flex-column flex-lg-row gap-3 gap-lg-4">
                <div>
                  <div className="mb-3">
                    <Label htmlFor="contact_name" className="form-label">
                      {t("avatar")}
                    </Label>
                    <div
                      className="position-relative"
                      style={{
                        width: "200px",
                        height: "200px",
                        border: "1px solid var(--vz-input-border-custom)",
                        overflow: "hidden",
                        borderRadius: "var(--vz-border-radius)",
                      }}
                    >
                      <img
                        src={data?.profile?.image_url || noUser}
                        alt={`preview-user`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null; // prevents looping
                          currentTarget.src = noUser;
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex-grow-1 mt-4">
                  <Row>
                    <Col md={12} lg={12}>
                      <Card>
                        <CardBody>
                          <Row>
                            <Col md={3} lg={3}>
                              <div className="mb-3">
                                <Label htmlFor="name" className="form-label">
                                  {t("User ID")}
                                </Label>
                                <div className="cursor-pointer">
                                  <CopyWrapper contentCopy={data?.id}>
                                    {data?.id}
                                  </CopyWrapper>
                                </div>
                              </div>
                            </Col>
                            <Col md={3} lg={3}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="platform"
                                  className="form-label"
                                >
                                  {t("Platform")}
                                </Label>

                                <div className="d-flex flex-column gap-1">
                                  <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                                    <div style={{ width: "25px" }}>
                                      {imgPlatform && (
                                        <img
                                          src={imgPlatform}
                                          width={25}
                                          height={25}
                                          alt="user_provider"
                                        />
                                      )}
                                    </div>
                                    <div className="cursor-pointer">
                                      {t(
                                        capitalizeFirstLetter(
                                          lowPlatform === "default" ||
                                            lowPlatform == "guest"
                                            ? "Email"
                                            : lowPlatform
                                        )
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>

                            <Col md={3} lg={3}>
                              <div className="mb-3">
                                <Label htmlFor="address" className="form-label">
                                  {t("OS")}
                                </Label>

                                <div className="d-flex align-items-center">
                                  <div
                                    style={{ width: "25px" }}
                                    className="me-1"
                                  >
                                    {imgOS ? (
                                      <img
                                        src={imgOS}
                                        width={20}
                                        height={20}
                                        alt="platform"
                                      />
                                    ) : (
                                      <span
                                        className={`bg-secondary`}
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          borderRadius: "3px",
                                        }}
                                      ></span>
                                    )}
                                  </div>
                                  <div>
                                    {t(
                                      LIST_OPTION_OS?.find(
                                        (item) => item?.value === deviceOS
                                      )?.label ?? ""
                                    )}
                                  </div>
                                </div>
                              </div>
                            </Col>

                            <Col md={3} lg={3}>
                              <div className="mb-3">
                                <Label htmlFor="channel" className="form-label">
                                  {t("Channel")}
                                </Label>
                                <div
                                  className="d-flex flex-column gap-1"
                                  style={{ minWidth: "100px" }}
                                >
                                  <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                                    <div style={{ width: "25px" }}>
                                      {imgChannel && (
                                        <img
                                          src={imgChannel}
                                          width={25}
                                          height={25}
                                          alt="channel"
                                        />
                                      )}
                                    </div>
                                    <div className="cursor-pointer">
                                      {t(
                                        LIST_CHANNEL_USER_OPTION?.find(
                                          (item: any) =>
                                            String(item?.value) ===
                                            String(data?.install_source)
                                        )?.label || ""
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>

                            <Col md={3} lg={3}>
                              <div className="mb-3">
                                <Label htmlFor="field" className="form-label">
                                  {t("User Type")}{" "}
                                </Label>
                                <div style={{ minWidth: 80 }}>
                                  <span
                                    className={`rounded-pill badge bg-${
                                      COLOR_USER_TYPE[userType] || "secondary"
                                    }`}
                                  >
                                    {t(
                                      LIST_OPTION_USER_TYPE?.find(
                                        (item: any) =>
                                          String(item?.value) ===
                                          String(userType)
                                      )?.label || ""
                                    )}
                                  </span>
                                </div>
                              </div>
                            </Col>

                            <Col md={3} lg={3}>
                              <div className="mb-3">
                                <Label htmlFor="website" className="form-label">
                                  {t("Email")}
                                </Label>
                                <div className="cursor-pointer">
                                  <CopyWrapper contentCopy={data?.profile?.email}>
                                    {data?.profile?.email || "-"}
                                  </CopyWrapper>
                                </div>
                              </div>
                            </Col>

                            <Col md={3} lg={3}>
                              <div className="mb-3">
                                <Label htmlFor="website" className="form-label">
                                  {t("Email SNS")}
                                </Label>
                                <div className="cursor-pointer">
                                  <CopyWrapper contentCopy={emailSNS}>
                                    {emailSNS || "-"}
                                  </CopyWrapper>
                                </div>
                              </div>
                            </Col>

                            <Col md={3} lg={3}>
                              <div className="mb-3">
                                <Label htmlFor="website" className="form-label">
                                  {t("UUID")}
                                </Label>
                                <div className="cursor-pointer">
                                  <CopyWrapper
                                    contentCopy={
                                      data?.user_device?.device?.udid
                                    }
                                  >
                                    {data?.user_device?.device?.udid}
                                  </CopyWrapper>
                                </div>
                              </div>
                            </Col>

                            <Col md={3} lg={3}>
                              <div className="mb-3">
                                <Label htmlFor="website" className="form-label">
                                  {t("App Version")}{" "}
                                </Label>
                                <div>
                                  {data?.user_device?.app_build
                                    ? `${data?.user_device?.app_version} (${data?.user_device?.app_build})`
                                    : data?.user_device?.app_version}
                                </div>
                              </div>
                            </Col>

                            <Col md={3} lg={3}>
                              <div className="mb-3">
                                <Label htmlFor="address" className="form-label">
                                  {t("Device Model")}
                                </Label>
                                <div>{deviceModel}</div>
                              </div>
                            </Col>

                            <Col md={3} lg={3}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="manufacturer"
                                  className="form-label"
                                >
                                  {t("Manufacturer")}
                                </Label>
                                <div
                                  className="cursor-pointer"
                                >
                                  <CopyWrapper
                                    contentCopy={
                                      data?.user_device?.device?.manufacturer
                                    }
                                  >
                                    {`${
                                      data?.user_device?.device?.manufacturer ||
                                      ""
                                    }`}
                                  </CopyWrapper>
                                </div>
                              </div>
                            </Col>

                            <Col md={3} lg={3}>
                              <div className="mb-3">
                                <Label htmlFor="ip" className="form-label">
                                  {t("Ip Address")}
                                </Label>
                                <div
                                  className="cursor-pointer"
                                >
                                  <CopyWrapper
                                    contentCopy={data?.user_device?.ip_address}
                                  >
                                    {`${data?.user_device?.ip_address || ""}`}
                                  </CopyWrapper>
                                </div>
                              </div>
                            </Col>
                            
                            <Col md={3} lg={3}>
                              <div className="d-flex align-items-end">
                                <div className="form-check form-switch mb-0 mt-0 mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="is_active"
                                    name="is_active"
                                    checked={!!data?.is_active}
                                    onChange={(event: any) => {
                                      console.log("active");
                                    }}
                                    style={{cursor: "default"}}
                                  />

                                  <Label
                                    className="form-check-label"
                                    style={{cursor: "default"}}
                                    for="is_active"
                                  >
                                    {t("Label Active")}
                                  </Label>
                                </div>
                              </div>
                            </Col>

                            <Col md={3} lg={3}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="signup_date"
                                  className="form-label"
                                >
                                  {t("Signup Date")}
                                </Label>
                                <div>
                                  {formatDateStringToKorea(data?.registered_at)}
                                </div>
                              </div>
                            </Col>

                            <Col md={3} lg={3}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="last_activity_time"
                                  className="form-label"
                                >
                                  {t("Last Activity Time")}
                                </Label>
                                <div>
                                  {data?.last_activity_time
                                    ? formatDateStringToKorea(
                                        data?.last_activity_time
                                      )
                                    : "-"}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md={12} lg={12}>
                      <Card>
                        <CardBody>
                          <Row>
                            <Col md={2} lg={2}>
                              <div className="mb-3">
                                <Label htmlFor="lat" className="form-label">
                                  {t("Lat")}
                                </Label>
                                <div
                                  className="cursor-pointer"
                                  style={{ minWidth: "290px" }}
                                >
                                  <CopyWrapper contentCopy={data?.address?.lat}>
                                    {`${data?.address?.lat || "-"}`}
                                  </CopyWrapper>
                                </div>
                              </div>
                            </Col>

                            <Col md={2} lg={2}>
                              <div className="mb-3">
                                <Label htmlFor="long" className="form-label">
                                  {t("Long")}
                                </Label>
                                <div
                                  className="cursor-pointer"
                                  style={{ minWidth: "290px" }}
                                >
                                  <CopyWrapper
                                    contentCopy={data?.address?.long}
                                  >
                                    {`${data?.address?.long || "-"}`}
                                  </CopyWrapper>
                                </div>
                              </div>
                            </Col>
                            <Col md={3} lg={3}></Col>
                            <Col md={6} lg={6}>
                              <div className="mb-3">
                                <Label htmlFor="address" className="form-label">
                                  {t("Address")}
                                </Label>
                                <div
                                  className="cursor-pointer"
                                >
                                  <CopyWrapper
                                    contentCopy={data?.address?.address}
                                  >
                                    {`${data?.address?.address || "-"}`}
                                  </CopyWrapper>
                                </div>
                              </div>
                            </Col>

                            <Col md={6} lg={6}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="short_address"
                                  className="form-label"
                                >
                                  {t("Short Address")}
                                </Label>
                                <div
                                  className="cursor-pointer"
                                >
                                  <CopyWrapper
                                    contentCopy={data?.address?.short_address}
                                  >
                                    {`${data?.address?.short_address || "-"}`}
                                  </CopyWrapper>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </div>
              </div>

              <Row className="mt-3"></Row>
            </div>
            <div></div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default AccountInfoTab;
